import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Container, Link, Typography, styled } from '@mui/material';

import { setSeoMeta } from './seo';

const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '&:last-of-type': {
    marginBottom: 0,
  },
}));

export default function Privacy({ appName }) {
  const { t } = useTranslation();

  useEffect(() => {
    setSeoMeta({
      title: t('privacy.seoTitle', { appName }),
      description: t('privacy.seoDescription', { appName }),
    });
  }, [t, appName]);

  return (
    <Container maxWidth="md" sx={{ padding: 3 }}>
      <Paragraph>
        <Trans
          i18nKey="privacy.p_intro"
          values={{ appName }}
          components={{ bold: <strong /> }}
        />
      </Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_obtain')}
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="privacy.p_user_heading" components={{ bold: <strong /> }} />
        <br />
        {t('privacy.p_user_body')}
        <br />
        {t('privacy.p_user_marketing')}
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="privacy.p_auto_heading" components={{ bold: <strong /> }} />
        <br />
        {t('privacy.p_auto_body')}
      </Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_location')}
      </Paragraph>
      <Paragraph>{t('privacy.p_location')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_third_parties')}
      </Paragraph>
      <Paragraph>{t('privacy.p_third_aggregated')}</Paragraph>
      <Paragraph>{t('privacy.p_third_links_intro')}</Paragraph>
      <Paragraph>
        <ul>
          <li>
            <Link href="https://amplitude.com/privacy" target="_blank" rel="noopener noreferrer">
              Amplitude
            </Link>
          </li>
          <li>
            <Link href="https://superwall.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
              Superwall
            </Link>
          </li>
          <li>
            <Link href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">
              Firebase Crashlytics
            </Link>
          </li>
          <li>
            <Link href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">
              Google Analytics for Firebase
            </Link>
          </li>
        </ul>
      </Paragraph>
      <Paragraph>{t('privacy.p_disclose_intro')}</Paragraph>
      <Paragraph>
        <ul>
          <li>{t('privacy.li_disclose_law')}</li>
          <li>{t('privacy.li_disclose_safety')}</li>
          <li>{t('privacy.li_disclose_providers')}</li>
        </ul>
      </Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_ai')}
      </Paragraph>
      <Paragraph>{t('privacy.p_ai_features')}</Paragraph>
      <Paragraph>{t('privacy.p_ai_sensitive')}</Paragraph>
      <Paragraph>{t('privacy.p_ai_gdpr')}</Paragraph>
      <Paragraph>{t('privacy.p_ai_transfers')}</Paragraph>
      <Paragraph>{t('privacy.p_ai_retention')}</Paragraph>
      <Paragraph>
        {t('privacy.p_ai_policies_intro')}
        <ul>
          <li>
            <Link href="https://openai.com/policies/row-privacy-policy" target="_blank" rel="noopener noreferrer">
              {t('privacy.link_openai_privacy')}
            </Link>
          </li>
          <li>
            <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              {t('privacy.link_google_privacy')}
            </Link>
          </li>
        </ul>
      </Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_optout')}
      </Paragraph>
      <Paragraph>{t('privacy.p_optout')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_retention')}
      </Paragraph>
      <Paragraph>{t('privacy.p_retention')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_children')}
      </Paragraph>
      <Paragraph>{t('privacy.p_children_1')}</Paragraph>
      <Paragraph>{t('privacy.p_children_2')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_security')}
      </Paragraph>
      <Paragraph>{t('privacy.p_security')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_changes')}
      </Paragraph>
      <Paragraph>{t('privacy.p_changes')}</Paragraph>
      <Paragraph>{t('privacy.effective')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.h_consent')}
      </Paragraph>
      <Paragraph>{t('privacy.p_consent')}</Paragraph>
      <Paragraph variant="subtitle1" component="p">
        {t('privacy.contact_title')}
      </Paragraph>
      <Paragraph>{t('privacy.p_contact')}</Paragraph>
    </Container>
  );
}
